<template>
	<div>
		<notifications class="notify-position"/>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'App',
	mounted() {
		const token = this.$store.getters.getToken;
		if (token && !this.$websocket) {
			this.$initWebSocket(token);
		}
	}
}
</script>

<style lang="scss">
	@import 'assets/scss/style';
	@import 'vue2-animate/src/sass/vue2-animate';
	.notify-position {
		margin-top: 5.5rem;
	}
</style>
